<template>
  <section
    class="campsite-card"
    :class="{ desktop: $isDesktop, 'with-rating': rateCount >= 3 }"
    data-test="campsite-card"
  >
    <new-campsite-badge
      v-if="firstAvailableDate"
      :first-available-date="firstAvailableDate"
    />
    <section class="card-img" :class="{ 'no-primary': !primaryPhoto }">
      <client-only>
        <campsite-favourite-button
          :campsite-id="id"
          :campsite-name="name"
          class="sr-favourite"
        />
      </client-only>

      <slot name="image" :search-result-index="searchResultIndex" />
    </section>

    <section class="card-info">
      <slot name="next-open" />
      <div class="card-contents">
        <pu-rating-bubble
          :rating="rating10"
          :rate-count="rateCount"
          class="campsite-rating"
          data-nosnippet
        />
        <h2
          class="cs-name"
          :data-sctrack="`${String($route.name)}--PuCampsiteCard-H2`"
        >
          {{ name }}
        </h2>
        <pu-campsite-card-location-section v-bind="locationSectionProps" />
        <div class="ev" style="display: none">
          {{ expectedValue }}
        </div>
        <pu-nutshells
          v-if="nutshells.length"
          :nutshells="nutshells"
          class="nutshells"
        />
      </div>
      <slot name="footer" />
      <slot name="notes" />
    </section>
  </section>
</template>

<script lang="ts">
import { Component, Prop, Vue, toNative } from '~/utility/pu-class-decorator'
import BaseCampsiteCard from './BaseCampsiteCard.vue'
import { PuCampsiteCardLocationSectionProps } from './PuCampsiteCardLocationSectionProps'

@Component({
  mixins: [BaseCampsiteCard],
})
class PuCampsiteCard extends Vue {
  @Prop({ required: false })
  searchResultIndex: number

  get locationSectionProps(): PuCampsiteCardLocationSectionProps {
    return {
      hierarchyStringShort: this.hierarchyStringShort,
      distance: this.distance,
      isPointSearch: this.isPointSearch,
    }
  }
}

export default toNative(PuCampsiteCard)
</script>

<style scoped>
.campsite-card {
  display: flex;
  position: relative;
  flex-direction: column;
  align-self: flex-start;
  justify-content: space-between;
  text-align: center;
  overflow: hidden;
  background-color: white;
  border-radius: 0.5em;
  padding: 0;
  width: 100%;
  box-shadow: 0 0.33em var(--colour-dark-green);
  margin-bottom: 1.5em;
  max-width: 30em;
}

.card-info {
  padding: 0 1.3em 0;
  margin-top: 0.7em;
  position: relative;
  width: 100%;
  flex-grow: 1;
  text-align: left;
}

.card-img {
  position: relative;
  width: 100%;
  height: 69vw;
  display: block;
  overflow: hidden;
}

.card-img.no-primary {
  height: auto;
  background: none;
  overflow: visible;
}

.card-contents {
  margin-bottom: 0.4em;
}

.test-wrapper {
  position: relative;
}
.sr-favourite {
  position: absolute;
  right: 0.75em;
  top: 0.75em;
}

.cs-name {
  font-size: 1.25em;
  line-height: 1.15;
  margin-bottom: 0.45em;
  margin-right: 1.75em;
  overflow-wrap: break-word;
}

.nutshells {
  margin: 0.7em 0 0 0;
}

/* mobile landscape */
@media screen and (min-width: 320px) and (max-width: 998px) and (orientation: landscape) {
  .card-img {
    height: auto;
    width: auto;
  }
}

/* desktop & tablet */
.campsite-card.desktop {
  flex-direction: column;
  flex: 1;
  margin-bottom: 0.33em;
  max-width: none;
}

.desktop .card-img {
  height: auto;
  width: inherit;
  margin-bottom: 0;
}

.desktop .card-info {
  padding: 0 1.3em 0;
  margin-top: 0.7em;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
}
</style>
